import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../../constants/common'
import { isStaffUser } from '../../../../../../utils/user'
import {
  POST_ACTION_BLOCK_ITEM,
  POST_ACTION_BLOCK_USER,
  POST_ACTION_CONNECT_REQUEST,
  POST_ACTION_CREATE_REQUEST,
  POST_ACTION_EDIT,
  POST_ACTION_UNBLOCK_ITEM,
  POST_ACTION_UNBLOCK_USER,
} from '../../NewsboardPostHeader.constants'

import { POST_BLOCK_STATUS } from './useNewsboardPostHeaderItemActions.constants'

export function isPostBlockStatus(status) {
  return status === POST_BLOCK_STATUS
}

export function getPostHeaderActions({ permissions = EMPTY_OBJECT, t, user }) {
  return [
    ...(permissions.can_edit
      ? [
          {
            label: t('Newsboard.EditActionOptionKey'),
            value: POST_ACTION_EDIT,
          },
        ]
      : EMPTY_LIST),
    ...(permissions.can_block_post
      ? [
          {
            label: t('Newsboard.BlockPostActionOptionKey'),
            value: POST_ACTION_BLOCK_ITEM,
          },
        ]
      : EMPTY_LIST),
    ...(permissions.can_unblock_post
      ? [
          {
            label: t('Newsboard.UnblockPostActionOptionKey'),
            value: POST_ACTION_UNBLOCK_ITEM,
          },
        ]
      : EMPTY_LIST),
    ...(permissions.can_block_user
      ? [
          {
            label: t('Newsboard.BlockUserActionOptionKey'),
            value: POST_ACTION_BLOCK_USER,
          },
        ]
      : EMPTY_LIST),
    ...(permissions.can_unblock_user
      ? [
          {
            label: t('Newsboard.UnblockUserActionOptionKey'),
            value: POST_ACTION_UNBLOCK_USER,
          },
        ]
      : EMPTY_LIST),
    ...(isStaffUser(user) && permissions.can_edit
      ? [
          {
            label: t('Newsboard.ConnectRequestActionOptionKey'),
            value: POST_ACTION_CONNECT_REQUEST,
          },
          {
            label: t('Newsboard.AddNewRequestActionKey'),
            value: POST_ACTION_CREATE_REQUEST,
          },
        ]
      : EMPTY_LIST),
    // for next iteration
    // {
    //   value: POST_ACTION_REPORT_USER,
    //   label: t('Newsboard.ReportUserActionOptionKey'),
    // },
    // {
    //   value: POST_ACTION_REPORT_POST,
    //   label: t('Newsboard.ReportPostActionOptionKey'),
    // },
    // null,
    // {
    //   value: POST_ACTION_ARCHIVE_ITEM,
    //   label: t('Newsboard.ArchiveActionOptionKey'),
    // },
  ]
}
